  <script>
import { mapGetters } from 'vuex'
import NavBar from './components/root/navbar'
import SideBar from './components/root/sidebar'
// import showLoader from './plugins/http'


export default {
  name: 'HumanFirewall',
  components: {
    NavBar, SideBar
  },
  data(){
    return {
        showFooter:false,
        inLoginPage : false,
    }
  },
  computed: {
    ...mapGetters(['shouldShowNavigation']),
  },
  mounted() {

      this.user = JSON.parse(localStorage.getItem('user'));
      if( this.$route.path.indexOf('/login') != -1) {
        this.inLoginPage = true;
      } else {
        this.inLoginPage = false;
      }
    },
  watch:{
    '$route' : function() {
        setTimeout(function(){
              if($('.header').length > 0) {
                var height = window.innerHeight;
                $('#main-hf-wrapper-div').height(height - 60);
              } else {
                var height = window.innerHeight;
                $('#main-hf-wrapper-div').height(height);
              }
            },100);
        // this.showFooter = true;
        if( this.$route.path.indexOf('/terms') != -1 || this.$route.path.indexOf('/privacy') != -1 || this.$route.path.indexOf('/reported_mails') != -1 || this.$route.path.indexOf('/qrcode') != -1) {
          this.showFooter = false;  
        }

        if( this.$route.path.indexOf('/login') != -1 || this.$route.path.indexOf('/secure-login') != -1) {
          this.inLoginPage = true;
        } else {
          this.inLoginPage = false;
        }
        
    }
  }
}
</script>
  
<template>
  <div id="app" >
      <side-bar v-if="shouldShowNavigation"></side-bar>
      <div class="page-container" v-bind:class="{'loginpage-container':inLoginPage == true }" > 
       <nav-bar v-if="shouldShowNavigation"></nav-bar>
          <router-view :key="$route.fullPath"></router-view>
          <div class="container-fluid container-fixed-lg footer" v-show="showFooter">
            <div class="copyright sm-text-center">
              <p class="small no-margin pull-left sm-pull-reset">
                <span class="hint-text">Copyright &copy; {{ getCurrentYear() }} </span>
                <span class="font-montserrat">EmailRemediator.com</span>.
                <span class="hint-text">All rights reserved. </span>
                <span class="sm-block"><a href="/terms" class="m-l-10 m-r-10">Terms of use</a> | <a href="/privacy" class="m-l-10">Privacy Policy</a></span>
              </p>
              <div class="clearfix"></div>
            </div>
          </div>
      </div>
    </div>
      
  </div>
</template>






// WEBPACK FOOTER //
// src/Root.vue